import { isAutomated } from "../gitlabHtml";

const byCreatedAtAsc = (a, b) => new Date(a.createdAt) - new Date(b.createdAt);

// Summarise the unresolved threads the viewer opened on someone else's MR and
// how many have since had a human reply. GitLab only clears a blocking thread
// on resolve, but authors often answer without resolving, so an unresolved
// count alone cannot tell "waiting on the author" from "waiting on me".
export const getReviewerThreads = (discussions, viewerUsername) => {
	if (!viewerUsername) return null;

	let started = 0;
	const replies = [];

	for (const discussion of discussions || []) {
		if (!discussion?.resolvable || discussion.resolved) continue;
		// With the oldest notes paged away the thread's opener is unknowable.
		if (discussion.notes?.pageInfo?.hasPreviousPage) continue;

		const notes = (discussion.notes?.nodes || [])
			.filter((note) => note && !note.system && note.author)
			.sort(byCreatedAtAsc);
		if (notes[0]?.author.username !== viewerUsername) continue;

		started++;
		const latest = notes.filter((note) => !isAutomated(note.author)).at(-1);
		if (latest && latest.author.username !== viewerUsername) {
			replies.push({
				id: discussion.id,
				createdAt: latest.createdAt,
				url: latest.url,
				author: {
					name: latest.author.name || latest.author.username,
					username: latest.author.username,
				},
			});
		}
	}

	if (started === 0) return null;

	replies.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
	return { started, replied: replies.length, replies };
};

// A reply on the viewer's own thread hands the ball back to them, unless they
// have already approved and the thread is just left open.
export const needsReviewerFollowUp = (mr) =>
	mr?.reviewerThreads?.replied > 0 && mr.myReview !== "APPROVED";
